"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_styles_1 = require("./Card.styles");
var TradeInSection_1 = __importDefault(require("./TradeInSection"));
var formatAndDropDecimal_1 = __importDefault(require("../../../utils/formatAndDropDecimal"));
var PriceBreakDown = function (_a) {
    var appliedTrade = _a.appliedTrade, showNSFVerbiage = _a.showNSFVerbiage, taxTitleReg = _a.taxTitleReg, total = _a.total, totalDiscount = _a.totalDiscount, transportCost = _a.transportCost, tradeDown = _a.tradeDown, card = _a.card;
    var subTotal = total + transportCost + taxTitleReg;
    return (react_1.default.createElement("ul", { className: "m-0 flex w-full flex-col gap-8 p-0" },
        react_1.default.createElement(Card_styles_1.LineItem, null,
            react_1.default.createElement("span", null, "Vehicle Price"),
            react_1.default.createElement("span", null,
                "$",
                (0, formatAndDropDecimal_1.default)(total + totalDiscount))),
        react_1.default.createElement(Card_styles_1.LineItem, { className: totalDiscount > 0 ? '' : 'hidden' },
            react_1.default.createElement("span", null, "Discount"),
            react_1.default.createElement("span", null,
                "- $",
                (0, formatAndDropDecimal_1.default)(totalDiscount))),
        react_1.default.createElement(Card_styles_1.LineItem, null,
            react_1.default.createElement("span", null,
                showNSFVerbiage ? 'Nonrefundable s' : 'S',
                "hipping fee"),
            react_1.default.createElement("span", null,
                "$",
                (0, formatAndDropDecimal_1.default)(transportCost))),
        react_1.default.createElement(Card_styles_1.LineItem, null,
            react_1.default.createElement("span", null, "Est. tax, title, registration"),
            react_1.default.createElement("span", null,
                "$",
                (0, formatAndDropDecimal_1.default)(taxTitleReg))),
        tradeDown !== 0 && appliedTrade && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Card_styles_1.GreyBarSpace, null),
            react_1.default.createElement(Card_styles_1.LineItem, null,
                react_1.default.createElement(Card_styles_1.Title, null, "Subtotal"),
                react_1.default.createElement(Card_styles_1.Title, null,
                    "$",
                    (0, formatAndDropDecimal_1.default)(subTotal))))),
        appliedTrade && react_1.default.createElement(TradeInSection_1.default, { tradeInCredit: tradeDown, card: card })));
};
exports.default = PriceBreakDown;
//# sourceMappingURL=PriceBreakDown.js.map